import React from "react"

const CentralStoreIcon = ({
  color = "#8B909A",
  size = 18,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <path d="M17.6549 3.88119L9.18227 0.0469031C9.04378 -0.0157806 8.88498 -0.0156048 8.74668 0.0472547L0.309165 3.88154C0.120867 3.96711 0 4.15481 0 4.36164V17.4727C0 17.7639 0.23611 18 0.527345 18H17.4375C17.7288 18 17.9649 17.7639 17.9649 17.4727V4.36164C17.9648 4.15453 17.8436 3.96655 17.6549 3.88119ZM12.3047 14.8359C12.5959 14.8359 12.832 14.5998 12.832 14.3086V13.7812H13.8867V16.9453H10.7226V13.7812H11.7773V14.3086C11.7773 14.5999 12.0134 14.8359 12.3047 14.8359ZM13.8867 12.7266H10.1953C9.90406 12.7266 9.66795 12.9627 9.66795 13.2539V16.9453H8.2617C8.2617 16.1079 8.2617 9.79838 8.2617 9.03514C8.2617 8.74391 8.02559 8.5078 7.73435 8.5078H4.04294V7.45311H13.8867V12.7266ZM4.04294 12.7266V9.56249H5.09763V10.0898C5.09763 10.3811 5.33374 10.6172 5.62497 10.6172C5.91621 10.6172 6.15232 10.3811 6.15232 10.0898V9.56249H7.20701V12.7266H4.04294ZM4.04294 13.7812H5.09763V14.3086C5.09763 14.5998 5.33374 14.8359 5.62497 14.8359C5.91621 14.8359 6.15232 14.5998 6.15232 14.3086V13.7812H7.20701V16.9453H4.04294V13.7812ZM16.9101 16.9453H14.9414V6.92576C14.9414 6.63453 14.7053 6.39842 14.4141 6.39842H3.5156C3.22436 6.39842 2.98825 6.63453 2.98825 6.92576V16.9453H1.05465V4.70125L8.96528 1.10637L16.9101 4.70184V16.9453Z" fill="currentColor"/>
<path d="M6.85547 4.11328C6.85547 4.40452 7.09158 4.64063 7.38281 4.64063H10.5469C10.8381 4.64063 11.0742 4.40452 11.0742 4.11328C11.0742 3.82205 10.8381 3.58594 10.5469 3.58594H7.38281C7.09158 3.58594 6.85547 3.82205 6.85547 4.11328Z" fill="currentColor"/>
    </svg>
  )
}

export default CentralStoreIcon
